import React from "react";
import { NavLink } from "react-router-dom";

export default function Mealcard({ detail }) {
  if (!detail?.length) return null;

  return (
    <div className="meals">
      {detail.map((meal) => (
        <div className="mealImg" key={meal.idMeal}>
          <img src={meal.strMealThumb} alt={meal.strMeal} />
          <p>{meal.strMeal}</p>
          <NavLink to={`/${meal.idMeal}`}>
            <button type="button">Recipe</button>
          </NavLink>
        </div>
      ))}
    </div>
  );
}
